// Ступень промокода: скидка discount_value при сумме от min_order_sum
export interface IPromoTier {
  min_order_sum: number
  discount_value: number
}

export interface ICreatePromo extends Components.Schemas.ICreatePromo {
  min_order_sum?: number
  // Следующие ступени после базовой (min_order_sum + discount_value)
  tiers?: IPromoTier[]
  discount_charge_type?: EDiscountChargeType
  visability_on_seller_page?: boolean
  first_order_only?: boolean
}
export interface IApplyPromo extends Components.Schemas.IApplyPromo {}
export interface IPromoCode extends Components.Schemas.IPromoCode {
  min_order_sum?: number
  tiers?: IPromoTier[]
  discount_charge_type?: EDiscountChargeType
  visability_on_seller_page?: boolean
  first_order_only?: boolean
}
export interface IGetPromoCodesQuery
  extends Components.Schemas.IGetPromoCodesQuery {}
export interface IGetPromoCodesResponse
  extends Components.Schemas.IGetPromoCodesResponse {}
export interface IGetHelperProductsQuery
  extends Components.Schemas.IGetHelperProductsQuery {}
export interface IHelperProductsResponse
  extends Components.Schemas.IHelperProductsResponse {}

export interface IUpdatePromoStatus
  extends Components.Schemas.IUpdatePromoStatus {}

export enum EDiscountType {
  PERCENT = 'PERCENT',
  FIXED = 'FIXED'
}

export enum EDiscountChargeType {
  STORE = 'STORE',
  SELLER = 'SELLER'
}

export enum EPromoStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED' // Computed
}

export enum EPromoTargetType {
  GLOBAL = 'GLOBAL',
  SPECIFIC = 'SPECIFIC'
}

export enum EPromoCreatorType {
  ADMIN = 'ADMIN',
  SELLER = 'SELLER'
}
